import { FC } from "react";
import DynamicScroll from "components/common/DynamicScroll/DynamicScroll";

const MAX_HEIGHT_BEFORE_SCROLL = 70;

type ModalBodyProps = {
  className?: string;
};

const ModalBody: FC<ModalBodyProps> = function (props) {
  const { children, className = "" } = props;

  return (
    <DynamicScroll maxHeightBeforeScroll={MAX_HEIGHT_BEFORE_SCROLL} className={`cb-modal__body ${className}`}>
      {children}
    </DynamicScroll>
  );
};

export default ModalBody;

ModalBody.defaultProps = {
  className: "",
};
